import styled from "styled-components"
import theme from "./index"
import { TinyColor } from "@ctrl/tinycolor"
import { ColorInput } from "@ctrl/tinycolor/dist"

const ParallelogramButton = styled.button<{ color?: keyof typeof theme.colors }>`
  color: ${({ theme, color }) =>
    new TinyColor((color ? theme.colors[color] : theme.colors.green) as ColorInput).getLuminance() > 0.179
      ? "black"
      : "white"};
  cursor: pointer;
  transform: skew(-20deg);
  border: 1px solid ${({ theme }) => theme.colors.greenDark};
  background-color: ${({ theme, color }) => (color ? theme.colors[color] : theme.colors.green)};
  // gapes
  :not(:last-child) {
    margin-right: 5px;
  }
  div {
    transform: skew(20deg);
  }
  font-size: 14px;
  svg {
    vertical-align: middle;
    margin-bottom: 1px;
  }
`

export default ParallelogramButton
